// @flow

import React from 'react';
import ButtonContainer from './button.container';
import { getVariant, getColor, getSize } from './helpers';
import { generateSlug } from '../../helpers';

import type { ACFProps } from './types';

const ACFButton = ({
  icon,
  position,
  template,
  text,
  page,
  url,
  with_icon,
  size,
  type,
  hash,
}: ACFProps) => (
  <ButtonContainer
    variant={getVariant(template)}
    colors={getColor(template)}
    position={position}
    href={url || page || (hash && `#${generateSlug(hash)}`)}
    icon={icon}
    size={getSize(size, template)}
    withIcon={with_icon}
    type={type}
  >
    {text}
  </ButtonContainer>
);

ACFButton.defaultProps = {
  icon: '',
  size: 'default',
  type: null,
};

export default ACFButton;
